import fastCheckout from './fastCheckout.es';

export default {
  ...fastCheckout,
};
